import React from 'react';
import ChatInterno from '../components/chat/ChatInterno';

const ChatPage: React.FC = () => {
  return (
    <div style={{ height: 'calc(100vh - 160px)', minHeight: 400, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', minHeight: 0 }}>
        <ChatInterno onFechar={() => {}} fullPage />
      </div>
    </div>
  );
};

export default ChatPage;
